// extracted by mini-css-extract-plugin
export default {"sortRadio":"SortyBy_sortRadio__y5Sm-","sortLabel":"SortyBy_sortLabel__AZcln","radioWrapper":"SortyBy_radioWrapper__csLGP"};